import { useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { NAVIGATION_COMPONENT_TYPE } from 'constant/NavigationConstant';
import {
  generateBreadCumbItemsV2,
  TenantHomeDashboardNavigationBar,
} from 'components/LayoutComponent/VerticalLayout/HeaderBar';
import { useGetBreadcumbItems } from 'services/v1/Common/NavBarMenuService';

import { FormTableAnalyticParameter } from 'components/ButtonComponent/ButtonTableAnalytic';
import { useGetTableAnalyticOptions } from 'services/v1/SystemTenant/AROKMS/TableAnalyticService';
import { useGetMyViewDetails } from 'services/v1/Tenant/ConfigurationService';
import { AnimatedPage } from 'components/AnimatedPage';
import { getPageAnimationByRefNavigation } from 'utils/Animation';
import { TableAnalyticComponent } from './components/TableAnalyticComponent';

export default function TableAnalyticPage() {
  const { subjectId } = useParams<{ subjectId: string }>();
  const [searchParams] = useSearchParams();
  const myViewId = searchParams.get('myViewId');
  const navigationRef = searchParams.get('ref');

  const { data: myViewDetails } = useGetMyViewDetails(myViewId);
  const [parameterValue, setParameterValue] = useState<FormTableAnalyticParameter | null>(null);

  const { data: breadCrumbItems } = useGetBreadcumbItems(subjectId, NAVIGATION_COMPONENT_TYPE.TABLE_ANALYTIC);
  const { data: tableAnalyticOptions } = useGetTableAnalyticOptions({
    enable: true,
    subjectId: subjectId,
  });

  const breadCrumbs = useMemo(() => {
    return generateBreadCumbItemsV2(breadCrumbItems?.data || []);
  }, [breadCrumbItems?.data]);

  useEffect(() => {
    if (myViewDetails?.data && myViewDetails?.data.tableAnalyticDefaultColumn) {
      setParameterValue(
        (prev) =>
          ({
            ...prev,
            columnColumn: tableAnalyticOptions?.data?.columnOptions.find(
              (option) => option.value === myViewDetails?.data.tableAnalyticDefaultColumn
            ),
            rowColumn: tableAnalyticOptions?.data?.rowOptions.find(
              (option) => option.value === myViewDetails?.data.tableAnalyticDefaultRow
            ),
            dataColumn: {
              label: 'Count',
              value: 'COUNT',
            },
          } as FormTableAnalyticParameter)
      );
    } else {
      if (tableAnalyticOptions?.data) {
        setParameterValue(
          (prev) =>
            ({
              ...prev,
              columnColumn: tableAnalyticOptions?.data?.columnOptions[0],
              rowColumn: tableAnalyticOptions?.data?.rowOptions[1],
              dataDecimals: '0',
              scale: undefined,
              dataColumn: {
                label: 'Count',
                value: 'COUNT',
              },
            } as FormTableAnalyticParameter)
        );
      }
    }
  }, [myViewDetails?.data, tableAnalyticOptions?.data]);

  return (
    <TenantHomeDashboardNavigationBar
      containerSx={{ height: '100%', flex: 1, flexDirection: 'column', overflowY: 'auto', display: 'flex' }}
      rootContainerSx={{ height: '95vh' }}
      breadCrumbs={breadCrumbs}
    >
      <AnimatedPage
        key={subjectId || 'default-table-anapyutics'}
        variants={getPageAnimationByRefNavigation(navigationRef)}
      >
        <Stack px={2} py={1}>
          {parameterValue && <TableAnalyticComponent parameterValue={parameterValue} subjectId={subjectId} />}
        </Stack>
      </AnimatedPage>
    </TenantHomeDashboardNavigationBar>
  );
}
